import { useAuthenticatedUserContext } from '@/contexts/user-context';

export const useHasLoyaltyProgram = (): boolean => {
  const { selectedRestaurantRelationship, supplierMap } =
    useAuthenticatedUserContext();
  const supplier = supplierMap[selectedRestaurantRelationship.supplierUUID];
  return (supplier?.supplier_loyalty_programs?.length ?? 0) > 0;
};
